import { render, staticRenderFns } from "./BannerBuilderLayoutSidebar.vue?vue&type=template&id=12bc38ad&scoped=true"
import script from "./BannerBuilderLayoutSidebar.vue?vue&type=script&lang=js"
export * from "./BannerBuilderLayoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./BannerBuilderLayoutSidebar.vue?vue&type=style&index=0&id=12bc38ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc38ad",
  null
  
)

export default component.exports